import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import AuthGuard from './components/AuthGuard';
import AuthCallback from './components/AuthCallback';
import './App.css';

// Main App component - Email Campaign System Only
const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Cognito redirects back here. Must stay OUTSIDE AuthGuard: the user
              is not signed in yet at this point, and guarding it would bounce
              them back to the hosted UI in a loop. */}
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Everything below requires a signed-in campaign-admin. This app was
              previously wide open — anyone with the URL could start campaigns,
              block domains and suppress contacts. */}
          <Route
            path="/admin"
            element={
              <AuthGuard>
                <AdminDashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/app/admin"
            element={
              <AuthGuard>
                <AdminDashboard />
              </AuthGuard>
            }
          />

          {/* Default redirect to admin */}
          <Route path="/" element={<Navigate to="/admin" />} />
          <Route path="/app" element={<Navigate to="/app/admin" />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
